/**
 * Coerce a FastAPI HTTPException ``detail`` (which may be a string OR an
 * object such as ``{error, hint}``) into a renderable string for
 * Sonner / native ``alert``. Without this, passing the raw object to a
 * React-rendering toast crashes with "Objects are not valid as a React
 * child" (minified React error #31) and white-screens the page.
 *
 * Order of preference:
 *   1. string detail                              → return as-is
 *   2. {error, hint, message, …}                  → "<error>: <hint>"
 *   3. Validation errors (FastAPI 422 list shape) → first ``msg``
 *   4. Anything else                              → JSON.stringify
 *   5. No detail                                  → fallback param
 */
export const errorMessage = (err, fallback = 'حَدَث خَطأ غَير مُتَوَقَّع') => {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const first = detail[0];
    if (first?.msg) return first.msg;
    return JSON.stringify(detail);
  }
  if (typeof detail === 'object') {
    if (detail.hint && detail.error) return `${detail.error}: ${detail.hint}`;
    if (detail.message) return detail.message;
    if (detail.hint)    return detail.hint;
    if (detail.error)   return String(detail.error);
    try { return JSON.stringify(detail); } catch { return fallback; }
  }
  return fallback;
};

export default errorMessage;
